const IconAccordionCross = (): JSX.Element => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 42 42"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.15385 28L0 25.8462L11.8462 14L0 2.15385L2.15385 0L14 11.8462L25.8462 0L28 2.15385L16.1538 14L28 25.8462L25.8462 28L14 16.1538L2.15385 28Z"
          fill="#4D0624"
        />
      </svg>
    </>
  );
};

export default IconAccordionCross;
